import { render, staticRenderFns } from "./CommissionsModal.vue?vue&type=template&id=6f8cbaca&scoped=true"
import script from "./CommissionsModal.vue?vue&type=script&lang=js"
export * from "./CommissionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8cbaca",
  null
  
)

export default component.exports